// src/hooks/usePagination.ts
import { useState } from "react";

export interface Pagination {
  currentPage: number;
  limitPagination: number;
  handlePageChange: (page: number) => void;
  handleLimitChange: (limit: number) => void;
}

export const usePagination = (
  initialPage: number = 1,
  initialLimit: number = 10
): Pagination => {
  const [currentPage, setCurrentPage] = useState<number>(initialPage);
  const [limitPagination, setLimitPagination] = useState<number>(initialLimit);

  const handlePageChange = (page: number) => setCurrentPage(page);
  const handleLimitChange = (limit: number) => setLimitPagination(limit);

  return {
    currentPage,
    limitPagination,
    handlePageChange,
    handleLimitChange,
  };
};
